import { useEffect } from "react";
import CustomInput from "../../../Components/Atoms/CustomInput";
import CustomButton from "../../../Components/Atoms/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { getCronReminderEmailsListRequest } from "../../../Redux/CronSettings/CronSettingsActions";
import { COMPONENTS } from "../../../Constant";

const ReminderEmails = ({ handleClose, data, email_formik }) => {
  const action = data ? "edit" : "new";
  useEffect(() => {
    if (action === "edit" && data) {
      Object.keys(email_formik.values).forEach((e) => {
        email_formik.setFieldValue(e, data[e]);
      });
    } else {
      email_formik.resetForm();
    }
  }, [data]);

  return (
    <>
      <form onSubmit={email_formik.handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <p className="mb-1">Email</p>
            <CustomInput
              component={COMPONENTS.EMAIL}
              type="text"
              name="email"
              placeholder="Enter email address"
              onChange={email_formik.handleChange}
              onBlur={email_formik.handleBlur}
              value={email_formik.values.email}
              formik={email_formik}
            />
          </div>
        </div>
        <div className="btnActnBar">
          <CustomButton
            btnType="secondary"
            onClick={() => handleClose()}
            label={"Cancel"}
            action={"CANCEL"}
          />
          <CustomButton label={"Save"} type="submit" action={"SAVE"} />
        </div>
      </form>
    </>
  );
};

export default ReminderEmails;
